import * as React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import Colors from "../../constants/Colors";
import { Text, View } from "../Themed";
import { Feather } from "@expo/vector-icons";

type Props = {
  intent: string;
};

export default function IntentBox(props: Props) {
  const { intent } = props;

  return (
    <>
      {intent === "buyer" && (
        <View style={[styles.container, { borderColor: Colors.go_blue_100 }]}>
          <Text
            size={12}
            lineHeight={16}
            weight="Bold"
            lightColor={Colors.go_blue_600}
            darkColor={Colors.go_blue_600}
          >
            B
          </Text>
        </View>
      )}
      {intent === "seller" && (
        <View
          style={[styles.container, { borderColor: Colors.tinted_yellow_200 }]}
        >
          <Text
            size={12}
            lineHeight={16}
            weight="Bold"
            lightColor={Colors.tinted_yellow_600}
            darkColor={Colors.tinted_yellow_600}
          >
            S
          </Text>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 4,
    borderWidth: 2,
    borderColor: Colors.go_blue_100,
    width: 20,
    height: 20,
    alignItems: "center",
    justifyContent: "center",
  },
});
